import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Switch } from './ui/switch';
import { toast } from 'sonner';
import { Fuel, Clock, Loader2 } from 'lucide-react';

const FuelToggle = ({ label, checked, onChange, disabled, testId }) => (
  <label className="flex-1 flex items-center justify-between gap-3 bg-zinc-900/60 border border-zinc-700 rounded-lg px-3 py-2">
    <span className={`text-sm font-medium ${checked ? 'text-green-400' : 'text-red-400'}`}>
      {label}: {checked ? 'Disponível' : 'Esgotado'}
    </span>
    <Switch checked={checked} onCheckedChange={onChange} disabled={disabled} data-testid={testId} />
  </label>
);

export const FuelStatusPanel = () => {
  const { api } = useAuth();
  const [status, setStatus] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api().get('/admin/station/fuel').then(res => setStatus(res.data)).catch(() => {});
  }, [api]);

  const update = async (field, value) => {
    const next = { has_gasoleo: status.has_gasoleo, has_gasolina: status.has_gasolina, [field]: value };
    setSaving(true);
    try {
      const res = await api().patch('/admin/station/fuel', next);
      setStatus({ ...status, ...next, fuel_updated_at: res.data.updated_at });
      toast.success('Estado do combustível actualizado');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao actualizar combustível');
    }
    setSaving(false);
  };

  if (!status) return null;

  return (
    <div className="mx-4 mt-4 bg-zinc-800 border border-zinc-700 rounded-xl p-4" data-testid="fuel-status-panel">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Fuel className="w-5 h-5 text-sonangol-orange" />
          <span className="text-white font-bold text-sm">Sonangol DC+ · Combustível</span>
          {saving && <Loader2 className="w-4 h-4 animate-spin text-zinc-400" />}
        </div>
        {status.fuel_updated_at && (
          <span className="flex items-center gap-1 text-xs text-zinc-400" data-testid="fuel-updated-at">
            <Clock className="w-3 h-3" />
            {new Date(status.fuel_updated_at).toLocaleString('pt-AO', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
          </span>
        )}
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <FuelToggle label="Gasóleo" checked={status.has_gasoleo} disabled={saving}
          onChange={(v) => update('has_gasoleo', v)} testId="toggle-gasoleo" />
        <FuelToggle label="Gasolina" checked={status.has_gasolina} disabled={saving}
          onChange={(v) => update('has_gasolina', v)} testId="toggle-gasolina" />
      </div>
    </div>
  );
};

export default FuelStatusPanel;
